import validateEmail from '../../utils/validateEmail';

const getValueIsValid = (value, validationType) => {
  switch (validationType) {
    case 'not-blank':
      return value.length > 0;
    case 'email':
      return validateEmail(value);
    default:
      return false;
  }
};

const validateForm = (form) => {
  let formIsValid = true;
  const inputs = form.querySelectorAll('[data-input-validation]');

  inputs.forEach((input) => {
    const container = input.closest('[data-input-container]');
    const validationType = input.getAttribute('data-input-validation');
    const isValid = getValueIsValid(input.value, validationType);

    if (isValid) {
      container.classList.remove('validation-error');
    } else {
      container.classList.add('validation-error');
      formIsValid = false;
    }
  });

  if (formIsValid) {
    form.setAttribute('action', '/cart/add');
  } else {
    form.setAttribute('action', 'invalid');
  }
};

export default () => {
  if (document.querySelector('[data-e-gift-card-form]') === null) {
    return;
  }

  document.addEventListener('input', (e) => {
    if (e.target.closest('[data-e-gift-card-form]')) {
      const form = e.target.closest('form');
      validateForm(form);
    }
  });

  document.addEventListener('click', (e) => {
    if (e.target.closest('[data-add-to-cart]')) {
      const el = e.target.closest('[data-add-to-cart]');
      el.classList.add('disabled');

      setTimeout(() => {
        el.classList.remove('disabled');
      }, 1000);
    }
  });

  document.addEventListener('submit', (e) => {
    if (e.target.matches('form[action="invalid"]')) {
      const form = e.target;
      form.classList.add('show-error-states');
      e.preventDefault();
    }
  });

  document.addEventListener('submit', (e) => {
    if (e.target.matches('form[action^="/cart/add"]')) {
      const el = e.target;
      const inputs = el.querySelectorAll('[data-e-gift-card-form] input[type="text"], textarea');

      inputs.forEach((input) => {
        input.value = '';
      });

      document.querySelectorAll('[data-input-validation]').forEach((input) => {
        input.classList.remove('validation-error');
      });

      el.classList.remove('show-error-states');
    }
  });

  document.querySelectorAll('form[data-product-id]').forEach((form) => {
    validateForm(form);
  });
};
